import React from 'react';
import { Link } from 'react-router-dom';

interface UnitLinkProps {
  id: string;
  courseId: string;
  unit: { title: string };
  sequenceId: string;
}

const UnitLink = ({
  id,
  courseId,
  unit,
  sequenceId,
}: UnitLinkProps) => {
  const { title } = unit;

  const coursewareUrl = (
    <Link className="uw-unit-outline-link" to={`/course/${courseId}/${sequenceId}/${id}`}>
      {title}
    </Link>
  );

  return <li>{coursewareUrl}</li>;
};

export default UnitLink;
